<template>
  <v-flex class="space-menu">
    <v-menu max-width="300px" offset-y content-class="space-menu-content">
      <v-btn slot="activator" flat>
        <span class="current-space-name">{{ currentSpace.name }}</span>
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="space in availableSpaces"
          :key="space.id"
          data-tid="select-space"
          @click="selectSpace(space.id)"
        >
          <v-list-tile-title v-text="space.name" />
        </v-list-tile>

        <v-divider v-if="spaces.length > 1" />
        <v-list-tile
          key="all-spaces"
          class="space-menu-btn"
          @click="showAllSpaces"
        >
          <v-list-tile-title v-text="'All Spaces'" />
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-flex>
</template>

<script>
import UDialog from "@/components/UDialog";

export default {
  components: {
    UDialog,
  },
  props: {
    currentSpace: {
      type: Object,
      required: true,
    },
    spaces: {
      type: Array,
      required: true,
    },
    selectSpace: {
      type: Function,
      required: true,
    },
  },
  computed: {
    availableSpaces() {
      return this.spaces.filter((e) => e !== this.currentSpace);
    },
  },
  methods: {
    showAllSpaces() {
      this.$router.push("/spaces/");
    },
  },
};
</script>

<style lang="scss">
.space-menu {
  height: 100%;
}
.current-space-name {
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.space-menu-content {
  min-width: 117px !important;
  margin-top: -10px;
  .all-spaces-divider {
    margin-bottom: 5px;
  }
}
@media (max-width: 975px) {
  .current-space-name {
    max-width: 100px;
  }
}
@media (max-width: 960px) and (min-width: 772px) {
  .space-menu-content {
    margin-top: -2px;
  }
}
@media (max-width: 771px) {
  .space-menu-content {
    margin-top: -6px;
  }
}
@media (max-width: 604px) {
  .current-space-name {
    max-width: 200px;
  }
}
@media (max-width: 500px) {
  .current-space-name {
    max-width: 100px;
  }
}
@media (max-width: 405px) {
  .current-space-name {
    max-width: 60px;
  }
}
</style>
